export const PRODUCT_COLOR_VALUES = {
  Black: { hex: "#1a1a1a", label: { en: "Black", ar: "أسود" } },
  Blue: { hex: "#2563eb", label: { en: "Blue", ar: "أزرق" } },
  Green: { hex: "#00a44f", label: { en: "Green", ar: "أخضر" } },
  Red: { hex: "#dc2626", label: { en: "Red", ar: "أحمر" } },
  Yellow: { hex: "#eab308", label: { en: "Yellow", ar: "أصفر" } },
};

export function getColorHex(name) {
  return PRODUCT_COLOR_VALUES[name]?.hex || "#cbd5e1";
}

export function getColorLabel(name, language) {
  const lang = language?.startsWith("ar") ? "ar" : "en";
  return PRODUCT_COLOR_VALUES[name]?.label?.[lang] || name;
}

export function extractProductColors(attributes = []) {
  const colorAttr = attributes.find(
    (attr) =>
      attr.slug === "pa_color" || String(attr.name || "").toLowerCase() === "color",
  );

  return (colorAttr?.options || []).filter(Boolean);
}

export function buildCartKey(productId, color = "") {
  return color ? `${productId}::${color}` : String(productId);
}

export function resolveCartKey(item) {
  if (!item) return "";
  if (item.cartKey) return item.cartKey;
  return buildCartKey(item.id, item.color || "");
}
